import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { text } from '../../config/staticText.config';

import './DrawShapeButton.scss';

const DrawShapeButton = () => {
  const dispatch = useDispatch();
  const expandDrawPanel = useSelector(store => store.mapview.expandDrawPanel);

  return (
    <div
      className="draw-shape-button-container pointer"
      onClick={() =>
        dispatch({ type: 'EXPAND_DRAW_SHAPE_PANEL', bool: !expandDrawPanel })
      }
    >
      <div
        className={
          expandDrawPanel
            ? 'draw-shape-image-active'
            : 'draw-shape-image-inactive'
        }
      />
      {text.customShape}
    </div>
  );
};

export default DrawShapeButton;
